import { render, staticRenderFns } from "./RankingDetailsModal.vue?vue&type=template&id=2540955d&scoped=true"
import script from "./RankingDetailsModal.vue?vue&type=script&lang=js"
export * from "./RankingDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RankingDetailsModal.vue?vue&type=style&index=0&id=2540955d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540955d",
  null
  
)

export default component.exports